import { createFileRoute } from '@tanstack/react-router';
import { OnboardCodePage } from '@/features/onboarding';

export const Route = createFileRoute('/_public/onboard/code')({
  component: OnboardCodePage,
});
